import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Toast, showErrorToUser, useConfirm } from '@pletly/ui';
import { GetUserFilesDocument } from '%screens/profile/Files/__generated__/files.generated';
import { useDeleteFileMutation } from './__generated__/deleteFile.mutation.generated';
import { GetUserUploadedFilesDocument } from './__generated__/uploadedFiles.generated';

export const useDeleteFile = () => {
	const { t } = useTranslation();
	const { confirm } = useConfirm();
	const [deleteFile] = useDeleteFileMutation();

	const onDeletePress = useCallback(
		async <File extends { uuid: string; name: string }>(file: File) => {
			const confirmation = await confirm(
				t('post.delete-file'),
				t('post.are-you-sure-you-want-to-delete', { name: file.name }),
			);
			if (!confirmation) {
				return;
			}

			try {
				await deleteFile({
					variables: { uuid: file.uuid },
					refetchQueries: [GetUserFilesDocument, GetUserUploadedFilesDocument],
				});

				Toast.show({
					text1: t('post.file-deleted'),
					text2: t('post.file-has-been-deleted-successfully', { name: file.name }),
				});
			} catch (error) {
				console.error(error);

				showErrorToUser(error as Error);
			}
		},
		[t, confirm, deleteFile],
	);

	return { onDeletePress };
};
